import type { Quest, QuestGroupState } from "@ui-kit/QuestList";

export const advanceQuestToNextGroup = (
  questGroupState: QuestGroupState[],
  ruleId: string,
) => {
  // Create a deep copy of the questGroups array to avoid modifying the original
  const newQuestGroups = JSON.parse(JSON.stringify(questGroupState));
  let skipped = false;

  for (let i = 0; i < newQuestGroups.length; i++) {
    const currentGroup = newQuestGroups[i];

    const questIndex = currentGroup.quests.findIndex(
      (quest: Quest) => quest.ruleId === ruleId,
    );

    // If the quest is found in the current group
    if (questIndex !== -1) {
      // Check if there is a next group
      if (i + 1 < newQuestGroups.length) {
        // Remove the quest from the current group's quests array
        const [quest] = currentGroup.quests.splice(questIndex, 1);
        // Append the quest to the next group's quests array
        newQuestGroups[i + 1].quests.push(quest);
        skipped = true;
      }
      // Exit the loop after processing
      break;
    }
  }
  return { questGroups: newQuestGroups, skipped };
};
